var map = {
	"./de.json": 82349,
	"./en.json": 65953,
	"@freshsolutions/fresh-vue-forms/src/locale/de.json": 82349,
	"@freshsolutions/fresh-vue-forms/src/locale/en.json": 65953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25059;